import React, { useEffect } from "react";

import { Box } from "@mui/material";
import GridTierList from "../Components/TierList/GridLayout";
import SeoHead from "../Components/SEO/SeoHead";
import { BASE_SITE_URL } from "../config";
import { useTranslation } from "react-i18next";

const Grid = (props) => {
  const { t } = useTranslation();

  useEffect(() => {
    props.mainFunctions.loadMusicData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const { page } = props.state;
  if (page !== "gridPage") {
    props.basicFunctions.updateState({ page: "gridPage", typePrefix: "Grid", tierListName: "" });
  }

  const gridStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: t("grid.name"),
    applicationCategory: "Multimedia",
    operatingSystem: "Web",
    url: `${BASE_SITE_URL}/3x3Grid`,
    description: t("grid.description"),
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
  };
  return (
    <Box
      id="grid-page"
      key={`mainContentBoxDiv`}
      sx={{
        backgroundColor: "background.default",
        color: "text.primary",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <SeoHead
        title={t("grid.seoTitle")}
        description={t("grid.seoDescription")}
        path="/3x3Grid"
        keywords={t("grid.keywords", { returnObjects: true }) as string[]}
        structuredData={gridStructuredData}
      />
      <GridTierList {...props} />
    </Box>
  );
};

export default Grid;
